import styled from 'foundations-theming/utils';
import { NEPTUNE_LAYER } from 'foundations-components/transitional/constants';
const ToolbarIconGroup = styled.div.withConfig({
  displayName: "ToolbarIconGroup"
})([".hs-private.hs-private.hs-private &{display:inline-block;pointer-events:auto;position:relative;z-index:", ";}"], NEPTUNE_LAYER);
export default ToolbarIconGroup;